module.exports = __webpack_public_path__ + "img/copy-icon-white.18c0a169.svg";